module.exports = __webpack_public_path__ + "img/l5.db20966c.png";